var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-page__menu-item",on:{"click":_vm.click}},[(_vm.important)?_c('span',{staticClass:"profile-page__menu-item-important"},[_c('span',[_vm._v("!")])]):_vm._e(),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }